import dayjs from 'dayjs';

import type { TimeUnit } from '@cast/shared-types';

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;

const getTimeUnitAndStep = (
  seconds: number
): { unit: TimeUnit; step: number } | undefined => {
  if (seconds <= 0) {
    return undefined;
  }

  if (seconds % SECONDS_IN_DAY === 0) {
    return { unit: 'day', step: seconds / SECONDS_IN_DAY };
  }

  if (seconds % SECONDS_IN_HOUR === 0) {
    return { unit: 'hour', step: seconds / SECONDS_IN_HOUR };
  }

  if (seconds % SECONDS_IN_MINUTE === 0) {
    return { unit: 'minute', step: seconds / SECONDS_IN_MINUTE };
  }

  return { unit: 'second', step: seconds };
};

export const inferTimeUnitFromTimestamps = (
  timestamps: string[]
): { unit: TimeUnit; step: number } | undefined => {
  if (timestamps.length < 2) {
    return undefined;
  }

  const diffs: number[] = [];

  for (let i = 1; i < timestamps.length; i++) {
    const diff = dayjs(timestamps[i]).diff(dayjs(timestamps[i - 1]), 'second');

    if (diff > 0) {
      diffs.push(diff);
    }
  }

  if (diffs.length === 0) {
    return undefined;
  }

  const sortedDiffs = [...diffs].sort((a, b) => a - b);
  const median = sortedDiffs[Math.floor(sortedDiffs.length / 2)];

  return getTimeUnitAndStep(median);
};
